
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.467 7c1.992 0 3.612 1.664 3.612 3.708 0 2.045-1.62 3.709-3.612 3.709s-3.612-1.664-3.612-3.709c0-2.044 1.62-3.708 3.612-3.708M1 11.8a1 1 0 110-2h26.933c.43-2.716 2.744-4.8 5.534-4.8 2.79 0 5.104 2.084 5.534 4.8h4.044a1 1 0 110 2h-4.07c-.504 2.627-2.78 4.617-5.508 4.617s-5.004-1.99-5.507-4.617H1zm11.848 14.433c1.992 0 3.612-1.663 3.612-3.708 0-2.044-1.62-3.708-3.612-3.708s-3.612 1.664-3.612 3.708c0 2.045 1.62 3.708 3.612 3.708zm30.197-4.616a1 1 0 110 2h-24.69c-.503 2.627-2.78 4.616-5.507 4.616s-5.004-1.99-5.507-4.615H1a1 1 0 010-2.001h6.314c.43-2.716 2.744-4.8 5.534-4.8 2.79 0 5.104 2.084 5.534 4.8h24.663zM24.423 37.866c1.992 0 3.612-1.663 3.612-3.708s-1.62-3.708-3.612-3.708c-1.99 0-3.61 1.663-3.61 3.708s1.62 3.708 3.61 3.708zm18.622-4.616a1 1 0 110 2H29.93c-.503 2.627-2.779 4.616-5.507 4.616-2.727 0-5.003-1.99-5.506-4.616H1a1 1 0 110-2h17.89c.43-2.716 2.744-4.8 5.533-4.8 2.79 0 5.104 2.084 5.534 4.8h13.088z","fill-rule":"evenodd"}})])
          )
        }
      }
    